import { useEffect, useState } from 'react';

/**
 * Feature-detects Document Picture-in-Picture support in the current browser.
 *
 * Returns `false` during SSR and the first client render, then flips to the
 * real value after mount. The initial `false` matches the server snapshot so
 * hydration does not warn; consumers can treat it as "hide until we know."
 */
export const useIsDocumentPipSupported = (): boolean => {
  const [supported, setSupported] = useState(false);
  useEffect(() => {
    setSupported('documentPictureInPicture' in window);
  }, []);
  return supported;
};
